import script from "./CustomTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTabs.vue?vue&type=script&setup=true&lang=ts"

import "./CustomTabs.vue?vue&type=style&index=0&id=f3ed4482&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ed4482"]])

export default __exports__